export enum CameraEnum {
    PERSPECTIVE = "PERSPECTIVE",
    FRONT = "FRONT",
    SIDE = "SIDE",
    DETAIL = "DETAIL"
}